import styled, { css } from 'styled-components';
import {
    BUTTON_CONTENT_BASE,
    CONTENT_BASE,
    CONTENT_DISABLED,
    PRIMARY_BASE,
    PRIMARY_HOVER,
    PRIMARY_MUTED,
    PRIMARY_PRESS,
    TERTIARY_BACKGROUND,
    TERTIARY_BORDER
} from '@amzn/ring-common-style-library/lib/colors';
import {
    BODY_LARGE_MEDIUM
} from '@amzn/ring-common-style-library/lib/typography';
import { RatingStarIcon } from '../Icon';

const alignmentStyles = {
    left: css`
        align-items: flex-start;
        justify-content: flex-start;
    `,
    center: css`
        align-items: center;
        justify-content: center;
    `,
    right: css`
        align-items: flex-end;
        justify-content: flex-end;
    `
};

const directionStyles = {
    left: css`
        flex-direction: row;
    `,
    center: css`
        flex-direction: row;
    `,
    right: css`
        flex-direction: row-reverse;
    `
};

const indentationStyles = {
    left: css`
        padding-left: 7px;
    `,
    center: css`
        padding: 0px 7px;
    `,
    right: css`
        padding-right: 7px;
    `
};

const ratingButtonStates = css<{ disabled?: boolean; selected?: boolean }>`
    border: 1px solid ${TERTIARY_BACKGROUND};
    background: ${BUTTON_CONTENT_BASE};
    color: ${CONTENT_BASE};

    ${RatingStarIcon} {
        fill: none;
        stroke: ${CONTENT_BASE};
    }

    ${({ disabled }) =>
        !disabled && css`
        &:hover {
            background: ${BUTTON_CONTENT_BASE};
            border: 1px solid ${PRIMARY_HOVER};
            color: ${PRIMARY_HOVER};

            ${RatingStarIcon} {
                stroke: ${PRIMARY_HOVER};
            }
        }

        &:active {
            background: ${PRIMARY_PRESS};
            border: 1px solid ${PRIMARY_BASE};
            color: ${PRIMARY_MUTED};

            ${RatingStarIcon} {
                stroke: ${PRIMARY_MUTED};
            }
        }
    `}

    ${({ disabled }) =>
        disabled && css`
        background: ${TERTIARY_BACKGROUND};
        color: ${CONTENT_DISABLED};
        cursor: not-allowed;

        ${RatingStarIcon} {
            stroke: ${CONTENT_DISABLED};
        }
    `}

    ${({ selected }) =>
        selected && css`
        background: ${PRIMARY_PRESS};
        border: 1px solid ${PRIMARY_BASE};

        ${RatingStarIcon} {
            stroke: ${PRIMARY_MUTED};
            fill: ${PRIMARY_MUTED}
        }
    `}
`;

const SelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const SelectContainer = styled.div<{
    alignment: 'left' | 'center' | 'right';
}>`
    display: flex;
    ${({ alignment }) => directionStyles[alignment]}

    gap: 8px;
`;

const HeaderText = styled.div`
    display: flex;
    padding: 8px 0px;
    align-items: flex-start;
    align-self: stretch;

    ${BODY_LARGE_MEDIUM};
    color: ${CONTENT_BASE};
`;

const SelectItems = styled.div<{
    alignment: 'left' | 'center' | 'right';
    orientation: 'vertical' | 'horizontal';
    feedback: boolean;
}>`
    display: flex;
    flex-direction: ${({ orientation }) => (orientation === 'vertical' ? 'column' : 'row')};
    flex-wrap: wrap;
    ${({ alignment }) => alignmentStyles[alignment]}
    ${({ alignment, feedback }) => feedback && indentationStyles[alignment]}

    width: 100%;
    gap: 8px;
`;

const Indentation = styled.div`
    width: 1px;
    background: ${TERTIARY_BORDER};
    border-radius: 4px; /* Add rounded corners */

    display: flex;
    align-items: stretch;

`;

const RatingButton = styled.button<{
    disabled?: boolean;
    selected?: boolean;
}>`
    display: flex;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;

    ${ratingButtonStates}
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

    border-radius: 8px; 
`;

export default {
    HeaderText,
    Indentation,
    SelectContainer,
    SelectItems,
    SelectWrapper,
    RatingButton,
};